/* The Settings pages for inbound data sources and outbound ticketing systems, each named after the
 * page it opens and both under the integrations root, which a unified view would take over. The
 * root itself still answers, redirecting to the section an address meant. */
export const DATA_SOURCES_PATH = '/settings/integrations/data-sources'

export const TICKETING_SYSTEMS_PATH = '/settings/integrations/ticketing-systems'

export const LEGACY_INTEGRATIONS_PATH = '/settings/integrations'

/* The provider holds this address as its registered redirect URI, so it stays where it was. */
export const APPLICATION_CALLBACK_PATH = `${LEGACY_INTEGRATIONS_PATH}/applications/callback`

/* Any page of either integrations section, setup wizards and legacy addresses included. */
export const isIntegrationsPath = (pathname: string): boolean =>
  pathname.startsWith(DATA_SOURCES_PATH) ||
  pathname.startsWith(TICKETING_SYSTEMS_PATH) ||
  pathname.startsWith(LEGACY_INTEGRATIONS_PATH)

export const isIntegrationsListPath = (pathname: string): boolean =>
  pathname === DATA_SOURCES_PATH || pathname === TICKETING_SYSTEMS_PATH

/* A setup wizard inside either section: adding an instance, or editing one. */
export const isIntegrationSetupPath = (pathname: string): boolean =>
  isIntegrationsPath(pathname) && (pathname.includes('/add') || pathname.includes('/edit'))

export const isJiraSetupPath = (pathname: string): boolean =>
  pathname.startsWith(`${DATA_SOURCES_PATH}/atlassian_jira`)

/* A page inside either section rather than one of its two lists, such as a setup wizard. */
export const isIntegrationsSubPath = (pathname: string): boolean =>
  !isIntegrationsListPath(pathname) &&
  [DATA_SOURCES_PATH, TICKETING_SYSTEMS_PATH, LEGACY_INTEGRATIONS_PATH].some((root) =>
    pathname.startsWith(`${root}/`)
  )
